import type { ReactNode } from 'react';
import { memo } from 'react';

import type { FieldRenderProps } from '@/js/libs/final-form/index.ts';

import type { FormFieldPropsBase } from '../FormField/index.ts';
import { FinalFormFormField } from '../FormField/index.ts';
import { InputRenderer } from './InputRenderer.tsx';

type TextFieldProps = FieldRenderProps<string | undefined, HTMLElement> &
  FormFieldPropsBase & {
    floatOnly?: boolean;
    intOnly?: boolean;
    width?: string;
    iconStart?: ReactNode;
    iconEnd?: ReactNode;
    placeholder?: string;
  };

export const TextField = memo(function TextField({
  input,
  meta,
  label,
  labelTooltip,
  required,
  disabled,
  width,
  iconStart,
  iconEnd,
  renderError,
  ...props
}: TextFieldProps) {
  return (
    <FinalFormFormField
      meta={meta}
      label={label}
      labelTooltip={labelTooltip}
      required={required}
      disabled={disabled}
      name={input.name}
      renderError={renderError}>
      <InputRenderer
        {...input}
        error={meta.touched && (meta.error || meta.submitError)}
        disabled={disabled}
        width={width}
        iconStart={iconStart}
        iconEnd={iconEnd}
        {...props}
      />
    </FinalFormFormField>
  );
});
